import { Checkbox, Group } from '@mantine/core'
import { useTranslation } from 'react-i18next'

import { Input } from '@mantine/core'
import AppIcon from '../common/AppIcon'
import AppInputWrapper from './AppInputWrapper'
import { useDebouncedCallback } from '@mantine/hooks'
import { useEffect, useState } from 'react'

interface CustomProps extends React.ComponentPropsWithoutRef<typeof Checkbox> {
  entity?: string
  label?: string
  labelh?: string
  checked?: boolean
  onChange?: any
  debounced?: boolean
}

const AppCheckbox = ({
  entity,
  label,
  labelh,
  name,
  checked,
  onChange,
  debounced = true,
  ...otherProps
}: CustomProps) => {
  const { t } = useTranslation()
  const [localValue, setLocalValue] = useState<boolean>(checked || false)

  useEffect(() => {
    setLocalValue(checked || false)
  }, [checked])

  const debouncedOnChange = useDebouncedCallback(
    (v: boolean) => {
      onChange?.({ target: { name, value: v } })
    },
    300, // milisegundos de debounce
  )
  return (
    <AppInputWrapper>
      <Input.Wrapper>
        {label && <Input.Label>{t(label)}</Input.Label>}
        <Group>
          {entity && <AppIcon icon={entity} className="checkboxEntityIcon" />}
          <Checkbox
            {...otherProps}
            label={labelh && t(labelh)}
            checked={localValue}
            onChange={(_value) => {
              setLocalValue(_value?.target?.checked)
              if (onChange) {
                if (debounced) debouncedOnChange(_value.target.checked)
                else onChange(_value.target.checked)
              }
            }}
          />
        </Group>
      </Input.Wrapper>
    </AppInputWrapper>
  )
}

export default AppCheckbox
